module.exports = __webpack_public_path__ + "img/second_appointment_button3.9d296273.png";